import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../locale/useTranslation';
import { DAI_CHANNEL_TYPE, ENTITYNAME, TOAST_TYPES } from '../../framework/constant/constant';
import * as API from "../../framework/API/api";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useNavigate, useParams } from 'react-router-dom';
import SaveButton from '../../framework/forms/helpercomponents/buttons/SaveButton';
import CancelButton from '../../framework/forms/helpercomponents/buttons/CancelButton';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import RenderDataCard from './component/RenderDataCard';
import CopyableUrlField from './component/CopyableUrlField';
import DaiScteForm from './DaiScteForm';
import DaiInputForm from './DaiInputForm';
import DaiOutputForm from './DaiOutputForm';
import BossDialog from '../../components/BossDialog';
import LivePlayer from './component/LivePlayer';
import RefreshButton from '../../framework/forms/helpercomponents/buttons/RefreshButton';
import TooltipInfoCard from '../../components/TooltipInfoCard';
import { DaiTranscodingForm } from './DaiTranscodingForm';
import DaiAdInsertionForm from './DaiAdInsertionForm';
import ToastNotification from "../../components/ToastNotification";

const DaiChannelForm = () => {

  const lang = useTranslation();
  const navigate = useNavigate();
  const { SID } = useParams();

  const blankDataItem = {
    Name: "",
    ChannleType: {},
    FeedUrl: "",
    Input: {},
    Transcoding: {},
    Output: {},
    AdInsertion: {},
    AdDecisionServerUrl: "",
    VideoContentSourceUrl: "",
    IsPublished: false,
  };
  const [dataItem, setDataItem] = useState(blankDataItem);
  const [inputs, setInputs] = useState([]);
  const [outputs, setOutputs] = useState([]);
  const [transcodings, setTranscodings] = useState([]);
  const [tabNumber, setTabNumber] = useState('1');
  const [isLoading, setIsLoading] = useState(false);
  const defaultFormState = {
    Input: { show: false, mode: null, item: null },
    Output: { show: false, mode: null, item: null },
    Transcoding: { show: false, mode: null, item: null },
    AdInsertion: { show: false, mode: null, item: null },
  };
  const [showAddForm, setShowAddForm] = useState(defaultFormState);
  const [channelTypes, setChannelTypes] = useState([]);
  const [adInsertions, setAdInsertions] = useState([]);

  useEffect(() => {
    loadCombo();
  }, [])

  const loadCombo = async () => {
    let inputRes = await API.getDataLookup(ENTITYNAME.DAI_INPUTS, { sort: { Name: 1 } });
    setInputs(inputRes.data);
    let outputRes = await API.getDataLookup(ENTITYNAME.DAI_OUTPUTS, { sort: { Name: 1 } });
    setOutputs(outputRes.data);
    let transcodingRes = await API.getDataLookup(ENTITYNAME.DAI_TRANSCODINGS, { sort: { Name: 1 } });
    setTranscodings(transcodingRes.data);
    let adInsertionRes = await API.getDataLookup(ENTITYNAME.DAI_AD_INSERTIONS, { sort: { Name: 1 } });
    setAdInsertions(adInsertionRes.data);
    let channelTypeRes = Object.keys(DAI_CHANNEL_TYPE).map(x => {
      return { _id: DAI_CHANNEL_TYPE[x], Description: x }
    });
    setChannelTypes(channelTypeRes);
    if (!SID || SID == 0) {
      setDataItem({ ...dataItem, ChannleType: channelTypeRes?.length > 0 ? channelTypeRes[1] : {} });
    } else {
      loadEditData({ inputs: inputRes.data, outputs: outputRes.data, transcodings: transcodingRes.data, channelTypes: channelTypeRes, adInsertionRes: adInsertionRes.data });
    }
  }

  const loadEditData = async ({ inputs = [], outputs = [], transcodings = [], channelTypes = [], adInsertionRes = [] }) => {
    let res = await API.getEntity(ENTITYNAME.DAI_CHANNELS, parseInt(SID));
    console.log(res);
    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }
    let channelType = channelTypes?.length > 0 ? channelTypes.find((x) => x?._id == res?.data?.ChannleType) : {};
    setDataItem({
      ...dataItem,
      ...res.data,
      ChannleType: channelTypes?.length > 0 ? channelTypes.find((x) => x?._id == res?.data?.ChannleType) : {},
      Input: inputs?.length > 0 ? inputs.find((x) => x?._id == res?.data?.Input?._id) : {},
      Output: outputs?.length > 0 ? outputs.find((x) => x?._id == res?.data?.Output?._id) : {},
      Transcoding: transcodings?.length > 0 ? transcodings.find((x) => x?._id == res?.data?.Transcoding?._id) : {},
      AdInsertion: adInsertionRes?.length > 0 ? adInsertionRes.find((x) => x?._id == res?.data?.AdInsertion?._id) : {},
    });
    setTabNumber(channelType?._id == DAI_CHANNEL_TYPE.Without_SCTE ? "1" : "4");
  };

  const onChange = (e) => {
    if (e.target.name == "ChannleType") {
      setTabNumber(e.target.value._id == DAI_CHANNEL_TYPE.Without_SCTE ? "1" : "4");
    }
    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
  }

  const isValid = () => {
    if (!dataItem.Name || dataItem.Name.trim() == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
      return false;
    }
    if (!dataItem.ChannleType || Object.keys(dataItem.ChannleType).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_type_error_message });
      return false;
    }
    if (dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.Without_SCTE) {
      if (!dataItem.Input || Object.keys(dataItem.Input).length == 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_input_error_message });
        return false;
      }
      if (!dataItem.Transcoding || Object.keys(dataItem.Transcoding).length == 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_transcoding_configuration_error_message });
        return false;
      }
      if (!dataItem.Output || Object.keys(dataItem.Output).length == 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_output_error_message });
        return false;
      }
    } else if (dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.With_SCTE) {
      if (!dataItem?.VideoContentSourceUrl || dataItem?.VideoContentSourceUrl == "") {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_video_source_url_error_message });
        return false;
      }
      if (!dataItem?.VideoContentSourceUrl?.includes("https://") && !dataItem?.VideoContentSourceUrl?.includes(".m3u8")) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_video_source_url_error_message });
        return false;
      }
    }
    if (!dataItem?.AdDecisionServerUrl || dataItem?.AdDecisionServerUrl == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_ad_decision_server_error_message });
      return false;
    }
    if (!dataItem?.AdInsertion || Object.keys(dataItem?.AdInsertion).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_ad_insertion_configuration_error_message });
      return false;
    }
    return true
  }

  const handleSubmit = async () => {
    if (!isValid()) return;

    const saveData = (channlType) => {
      switch (channlType) {
        case DAI_CHANNEL_TYPE.Without_SCTE:
          return {
            Input: dataItem.Input && Object.keys(dataItem.Input).length > 0 ? { _id: dataItem?.Input?._id, Name: dataItem?.Input?.Name } : {},
            Transcoding: dataItem.Transcoding && Object.keys(dataItem.Transcoding).length > 0 ? { _id: dataItem?.Transcoding?._id, Name: dataItem?.Transcoding?.Name } : {},
            Output: dataItem.Output && Object.keys(dataItem.Output).length > 0 ? { _id: dataItem?.Output?._id, Name: dataItem?.Output?.Name } : {},
            checkDuplicate: true,
            query: [["Input._id", "=", dataItem.Input?._id]]
          }
        case DAI_CHANNEL_TYPE.With_SCTE:
          return {
            VideoContentSourceUrl: dataItem.VideoContentSourceUrl,
          }
        default:
          return {};
      }
    };

    let finalData = {
      _id: dataItem._id,
      SID: dataItem.SID,
      Name: dataItem.Name,
      ChannleType: dataItem?.ChannleType?._id,
      ...saveData(dataItem?.ChannleType?._id),
      AdInsertion: dataItem.AdInsertion && Object.keys(dataItem.AdInsertion).length > 0 ? { _id: dataItem?.AdInsertion?._id, Name: dataItem?.AdInsertion?.Name } : {},
      AdDecisionServerUrl: dataItem.AdDecisionServerUrl,
      Archive: dataItem.Archive ?? false,
    }

    try {
      const res = await API.saveData(ENTITYNAME.DAI_CHANNELS, finalData);
      if (res.success) {
        navigate(-1);
      } else if (res.code = 413) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Input is already used by another channel." });
      } else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });

      }
    } catch (error) {
      console.error("Error saving data:", error);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Unexpected error occurred. Please try again." });
    }
  }

  const handlePublishUnpublish = async () => {
    setIsLoading(true);
    let res = await API.publishChannel(dataItem._id);
    console.log(res);
    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
      setDataItem({ ...dataItem, ...res?.data });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
    setIsLoading(false);
  }

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
  };

  const handleStartStopChannel = async () => {
    setIsLoading(true);
    let res = await API.startStopChannel({ _id: dataItem?._id, ChannelId: dataItem?.ChannelId, Status: !dataItem?.IsPublished });
    console.log(res);
    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
      setDataItem({ ...dataItem, IsPublished: res?.data?.IsPublished });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
    setIsLoading(false);
  }

  const onCreateMasterClick = (key, item = null) => {
    setShowAddForm({
      ...defaultFormState,
      [key]: {
        show: true,
        mode: item ? "edit" : "add",
        item: item
      }
    });
  };

  const onConfigurationtSave = (item) => {
    setDataItem({ ...dataItem, Transcoding: item })
  }

  const onRefreshClick = async () => {
    await loadCombo();
  }

  const borderStyle = {
    border: "1px solid #ced4da",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#FAFAFA",
  };

  return (
    <div className='m-2'>
      <div className="flex-container wrap" style={{ marginLeft: "-10px" }}>
        <SaveButton onClick={handleSubmit} />
        <CancelButton onClick={() => navigate(-1)} />
        {SID > 0 && <ActionButton isLoading={isLoading} btnColor={dataItem?.ChannelId ? 'info' : 'success'} title={(dataItem?.IsPublished || dataItem?.ChannelId) ? lang.re_publish_button_tooltip : lang.publish_button_tooltip} name={(dataItem?.IsPublished || dataItem?.ChannelId) ? lang.re_publish_button_text : lang.publish_button_text} onClick={handlePublishUnpublish} />}
        {dataItem?.ChannelId && <ActionButton isLoading={isLoading} name={dataItem?.IsPublished ? "Stop" : "Start"} btnColor={dataItem?.IsPublished ? "danger" : "success"} onClick={handleStartStopChannel} />}
      </div>
      <div className='row mt-2'>
        <div className='col-7'>
          <div className='row mt-2'>
            <div className='col-6'>
              <label>{lang.name_label} *</label>
              <input
                type="text"
                name='Name'
                className="form-control form-control-sm"
                value={dataItem.Name}
                onChange={onChange}
              />
            </div>
            <div className='col-6'>
              <label>{lang.channel_type_label} *</label>
              <DropDownList
                style={{ backgroundColor: "white" }}
                data={channelTypes}
                name="ChannleType"
                textField="Description"
                dataItemKey="_id"
                value={dataItem.ChannleType}
                onChange={onChange}
              />
            </div>
          </div>
          {dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.Without_SCTE && <>
            <span>{lang.transcoding_label}</span>
            <div className="border p-2 form-group with-3d-effect" style={borderStyle}>
              <div className='row'>
                <div className="col-6">
                  <label className="form-label">{lang.input_label} *</label>
                  <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                    <div style={{ flexGrow: 1 }}>
                      <DropDownList
                        style={{ height: "32px", width: "100%" }}
                        data={inputs}
                        name="Input"
                        textField="Name"
                        dataItemKey="_id"
                        value={dataItem.Input}
                        onChange={onChange}
                      />
                    </div>
                    <button
                      type="button"
                      title={lang.create_input_button_tooltip}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                      style={{ height: "28px", width: "28px" }}
                      onClick={() => onCreateMasterClick("Input")}
                    >
                      <i className="fa-solid fa-plus"></i>
                    </button>
                    {dataItem.Input && dataItem.Input._id && (
                      <button
                        type="button"
                        title={lang.edit_input_button_tooltip}
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                        style={{ height: "28px", width: "28px" }}
                        onClick={() => onCreateMasterClick("Input", dataItem.Input)}
                      >
                        <i className="fa-solid fa-edit"></i>
                      </button>
                    )}
                  </div>
                  <a style={{ fontSize: "10px" }} href={dataItem?.Input?.Sources?.[0]?.Url} target="_blank">{dataItem?.Input?.Sources?.[0]?.Url}</a>
                </div>
                <div className="col-6">
                  <label>{lang.configuration_label} *</label>
                  <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                    <div style={{ flexGrow: 1 }}>
                      <DropDownList
                        style={{ height: "32px" }}
                        data={transcodings}
                        name="Transcoding"
                        textField="Name"
                        dataItemKey="_id"
                        value={dataItem.Transcoding}
                        onChange={onChange}
                      />
                    </div>
                    <button
                      type="button"
                      title={lang.create_configuration_button_tooltip}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                      style={{ height: "28px", width: "28px" }}
                      onClick={() => onCreateMasterClick("Transcoding")}
                    >
                      <i className="fa-solid fa-plus"></i>
                    </button>
                    {dataItem.Transcoding && dataItem.Transcoding._id && (
                      <button
                        type="button"
                        title={lang.edit_configuration_button_tooltip}
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                        style={{ height: "28px", width: "28px" }}
                        onClick={() => onCreateMasterClick("Transcoding", dataItem.Transcoding)}
                      >
                        <i className="fa-solid fa-edit"></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className='row mt-2'>
                <div className="col-6">
                  <label>{lang.output_configuration_label} *</label>
                  <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                    <div style={{ flexGrow: 1 }}>
                      <DropDownList
                        style={{ height: "32px" }}
                        data={outputs}
                        name="Output"
                        textField="Name"
                        dataItemKey="_id"
                        value={dataItem.Output}
                        onChange={onChange}
                      />
                    </div>
                    <button
                      type="button"
                      title={lang.create_output_button_tooltip}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                      style={{ height: "28px", width: "28px" }}
                      onClick={() => onCreateMasterClick("Output")}
                    >
                      <i className="fa-solid fa-plus"></i>
                    </button>
                    {dataItem.Output && dataItem.Output._id && (
                      <button
                        type="button"
                        title={lang.edit_output_button_tooltip}
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                        style={{ height: "28px", width: "28px" }}
                        onClick={() => onCreateMasterClick("Output", dataItem.Output)}
                      >
                        <i className="fa-solid fa-edit"></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>}
          <span>{lang.ad_insertion_label}</span>
          <div className="border p-2 form-group with-3d-effect" style={borderStyle}>
            <div className='row'>
              {dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.With_SCTE && <div className='col-12'>
                <label>{lang.video_content_source_url_label} *</label>
                <TooltipInfoCard
                  showLearnMore={true}
                  link="https://docs.aws.amazon.com/AmazonS3/latest/userguide/creating-buckets.html"
                  message="The video content source URL is the URL of the video content source. It can be a URL of a file or a S3 bucket."
                />
                <textarea
                  type="text"
                  name='VideoContentSourceUrl'
                  className="form-control form-control-sm"
                  value={dataItem.VideoContentSourceUrl}
                  onChange={onChange}
                />
              </div>}
              <div className='col-12'>
                <label>{lang.ad_decision_server_url_label} *</label>
                <TooltipInfoCard
                  showLearnMore={true}
                  link="https://docs.aws.amazon.com/AmazonS3/latest/userguide/creating-buckets.html"
                  message="The ad decision server URL is the URL of the ad decision server. It can be a URL of a file or a S3 bucket."
                />
                <textarea
                  type="text"
                  name='AdDecisionServerUrl'
                  className="form-control form-control-sm"
                  value={dataItem.AdDecisionServerUrl}
                  onChange={onChange}
                />
              </div>
              <div className='col-6 mt-2'>
                <label>{lang.configuration_label} *</label>
                <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                  <div style={{ flexGrow: 1 }}>
                    <DropDownList
                      data={adInsertions}
                      name="AdInsertion"
                      textField="Name"
                      dataItemKey="_id"
                      value={dataItem.AdInsertion}
                      onChange={onChange}
                    />
                  </div>
                  <button
                    type="button"
                    title={lang.create_adInsertion_button_tooltip}
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                    style={{ height: "28px", width: "28px" }}
                    onClick={() => onCreateMasterClick("AdInsertion")}
                  >
                    <i className="fa-solid fa-plus"></i>
                  </button>
                  {dataItem?.AdInsertion && dataItem?.AdInsertion?._id && (
                    <button
                      type="button"
                      title={lang.edit_adInsertion_button_tooltip}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                      style={{ height: "28px", width: "28px" }}
                      onClick={() => onCreateMasterClick("AdInsertion", dataItem.AdInsertion)}
                    >
                      <i className="fa-solid fa-edit"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-5">
          <div style={{ display: "flex", justifyContent: "space-between", width: "500px" }}>
            <label className='card-header p-1 bg-white'>{lang.preview_label}</label>
            {/* <RefreshButton onClick={onRefreshClick} /> */}
          </div>
          <div
            className="preview-container"
            style={{
              border: "2px solid white",
              overflow: "hidden",
              width: "500px",
              height: "300px",
              position: "relative",
              backgroundColor: "black"
            }}
          >
            {!dataItem?.IsPublished
              ? <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", color: "white" }}>{lang.no_preview_available_label}</div>
              : <LivePlayer streamUrl={dataItem?.HlsUrl} />}
          </div>
          <div className="row">
            {dataItem.HlsUrl && <div className='col-11 mt-2'>
              <CopyableUrlField
                label={lang.hls_url_label}
                value={dataItem.HlsUrl}
                fieldKey="hls"
              />
            </div>}
            {dataItem.DashUrl && <div className='col-11 mt-2'>
              <CopyableUrlField
                label={lang.dash_url_label}
                value={dataItem.DashUrl}
                fieldKey="dash"
              />
            </div>}
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-12 mb-4'>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={tabNumber}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                  {dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.Without_SCTE && <Tab label={lang.input_label} value="1" />}
                  {dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.Without_SCTE && <Tab label={lang.output_label} value="2" />}
                  {dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.Without_SCTE && <Tab label={lang.transcoding_label} value="3" />}
                  <Tab label={lang.ad_insertion_label} value="4" />
                  {dataItem?._id && dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.Without_SCTE && <Tab label={lang.sctes_label} value="5" />}
                </TabList>
              </Box>
              {dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.Without_SCTE &&
                <TabPanel value="1">
                  <RenderDataCard data={dataItem.Input || {}} />
                </TabPanel>
              }
              {dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.Without_SCTE &&
                <TabPanel value="2">
                  <RenderDataCard data={dataItem.Output || {}} />
                </TabPanel>
              }
              {dataItem?.ChannleType?._id == DAI_CHANNEL_TYPE.Without_SCTE &&
                <TabPanel value="3">
                  <RenderDataCard data={dataItem.Transcoding || {}} />
                </TabPanel>
              }
              <TabPanel value="4">
                <RenderDataCard data={dataItem.AdInsertion || {}} />
              </TabPanel>
              {dataItem?._id && <TabPanel value="5">
                <DaiScteForm ChannelId={dataItem?._id} />
              </TabPanel>}
            </TabContext>
          </Box>
        </div>
      </div>
      {showAddForm.Input.show && (
        <DaiInputForm
          item={showAddForm.Input.mode === "edit" ? showAddForm.Input.item : null}
          cancelEdit={() => setShowAddForm(defaultFormState)} refresh={loadCombo} setData={(data) => setDataItem({ ...dataItem, Input: data })}
        />
      )}
      {showAddForm.Output.show && <DaiOutputForm
        item={showAddForm.Output.mode === "edit" ? showAddForm.Output.item : {}}
        cancelEdit={() => setShowAddForm(defaultFormState)}
        refresh={loadCombo}
        setData={(data) => setDataItem({ ...dataItem, Output: data })}
      />}
      {showAddForm.Transcoding.show && (
        <BossDialog title={lang.configuration_label} width={"75%"} onClose={() => setShowAddForm({ ...showAddForm, Transcoding: false })} >
          <DaiTranscodingForm
            item={showAddForm.Transcoding.mode === "edit" ? showAddForm.Transcoding.item : {}}
            cancelEdit={() => { setShowAddForm(defaultFormState); loadCombo(); }} onSave={onConfigurationtSave} />
        </BossDialog>
      )}
      {showAddForm.AdInsertion.show && <DaiAdInsertionForm
        item={showAddForm.AdInsertion.mode === "edit" ? showAddForm.AdInsertion.item : {}}
        cancelEdit={() => setShowAddForm(defaultFormState)}
        refresh={loadCombo}
        setData={(data) => setDataItem({ ...dataItem, AdInsertion: data })}
      />}
    </div>
  )
}

export default DaiChannelForm